import Products from '../components/Products'
import HeroVideo from '../components/HeroVideo'
import About from '../components/About'
import Kolekcja from '../components/Kolekcja'
import Why from '../components/Why'
import Socials from '../components/Socials'
import Bar from '../components/Bar'
import Loading from '../components/Loading'

const Landing = () => {
  return (
    <div className="flex overflow-hidden flex-col items-center justify-center box-border bg-[#FFFFFF] mq450:box-border">
    <Loading />
    <Bar />
    <HeroVideo />
    <Products />
    <About />
    <Kolekcja />
    <Why />
    <Socials />
    </div>
  )
}

export default Landing
